import AtlantaImage from '@/images/destinations/popular/atlanta.jpg'
import AtlantaImageWebP from '@/images/destinations/popular/atlanta.webp'
import DallasImage from '@/images/destinations/popular/dallas.jpg'
import DallasImageWebP from '@/images/destinations/popular/dallas.webp'
import DenverImage from '@/images/destinations/popular/denver.jpg'
import DenverImageWebP from '@/images/destinations/popular/denver.webp'
import LosAngelesImage from '@/images/destinations/popular/los-angeles.jpg'
import LosAngelesImageWebP from '@/images/destinations/popular/los-angeles.webp'
import MiamiImage from '@/images/destinations/popular/miami.jpg'
import MiamiImageWebP from '@/images/destinations/popular/miami.webp'
import NewYorkImage from '@/images/destinations/popular/new-york-city.jpg'
import NewYorkImageWebP from '@/images/destinations/popular/new-york-city.webp'
import OrlandoImage from '@/images/destinations/popular/orlando.jpg'
import OrlandoImageWebP from '@/images/destinations/popular/orlando.webp'
import SanDiegoImage from '@/images/destinations/popular/san-diego.jpg'
import SanDiegoImageWebP from '@/images/destinations/popular/san-diego.webp'
import SanFranciscoImage from '@/images/destinations/popular/san-francisco.jpg'
import SanFranciscoImageWebP from '@/images/destinations/popular/san-francisco.webp'
import SeattleImage from '@/images/destinations/popular/seattle.jpg'
import SeattleImageWebP from '@/images/destinations/popular/seattle.webp'
import {
  Atlanta,
  Dallas,
  Denver,
  Miami,
  NewYork,
  LosAngeles,
  Orlando,
  SanDiego,
  SanFrancisco,
  Seattle
} from './svgs'

const DESTINATIONS = [
  {
    driveSearchCity: 'New York, NY',
    flySearchCity: 'New York',
    staySearchHref: '/hotel-deals/c3000016152/US/New-York/New-York-Hotels.html',
    image: NewYorkImage,
    imageWebP: NewYorkImageWebP,
    svg: NewYork,
    title: '24-HOUR EXCITEMENT',
    width: [1, 1, 1 / 2, 1 / 2, 2 / 3]
  },
  {
    driveSearchCity: 'Los Angeles, CA',
    flySearchCity: 'Los Angeles',
    staySearchHref:
      '/hotel-deals/c3000001947/US/California/Los-Angeles-Hotels.html',
    image: LosAngelesImage,
    imageWebP: LosAngelesImageWebP,
    svg: LosAngeles,
    title: 'CUTTING-EDGE COOL',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'Orlando, FL',
    flySearchCity: 'Orlando',
    staySearchHref: '/hotel-deals/c3000003349/US/Florida/Orlando-Hotels.html',
    image: OrlandoImage,
    imageWebP: OrlandoImageWebP,
    svg: Orlando,
    title: 'THEME PARK PARADISE',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'Atlanta, GA',
    flySearchCity: 'Atlanta',
    staySearchHref: '/hotel-deals/c3000003496/US/Georgia/Atlanta-Hotels.html',
    image: AtlantaImage,
    imageWebP: AtlantaImageWebP,
    svg: Atlanta,
    title: 'SWEET SOUTHERN CHARM',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'Dallas, TX',
    flySearchCity: 'Dallas',
    staySearchHref: '/hotel-deals/c3000021082/US/Texas/Dallas-Hotels.html',
    image: DallasImage,
    imageWebP: DallasImageWebP,
    svg: Dallas,
    title: 'FOOD CAPITAL',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'San Francisco, CA',
    flySearchCity: 'San Francisco',
    staySearchHref:
      '/hotel-deals/c3000002244/US/California/San-Francisco-Hotels.html',
    image: SanFranciscoImage,
    imageWebP: SanFranciscoImageWebP,
    svg: SanFrancisco,
    title: 'SOAK UP THE SCENES',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'Miami, FL',
    flySearchCity: 'Miami',
    staySearchHref: '/hotel-deals/c3000003311/US/Florida/Miami-Hotels.html',
    image: MiamiImage,
    imageWebP: MiamiImageWebP,
    svg: Miami,
    title: "IT'S BEACH TIME",
    width: [1, 1, 1 / 2, 1 / 2, 2 / 3]
  },
  {
    flySearchCity: 'Denver',
    driveSearchCity: 'Denver, CO',
    staySearchHref: '/hotel-deals/c3000002573/US/Colorado/Denver-Hotels.html',
    image: DenverImage,
    imageWebP: DenverImageWebP,
    svg: Denver,
    title: 'MILE-HIGH MAGIC',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    flySearchCity: 'Seattle',
    driveSearchCity: 'Seattle, WA',
    staySearchHref:
      '/hotel-deals/c3000023414/US/Washington/Seattle-Hotels.html',
    image: SeattleImage,
    imageWebP: SeattleImageWebP,
    svg: Seattle,
    title: 'PACIFIC NORTHWEST BEAUTY',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchCity: 'San Diego, CA',
    flySearchCity: 'San Diego',
    staySearchHref:
      '/hotel-deals/c3000002241/US/California/San-Diego-Hotels.html',
    image: SanDiegoImage,
    imageWebP: SanDiegoImageWebP,
    svg: SanDiego,
    title: 'RIDE THE WAVES',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  }
]

export default DESTINATIONS
